export default "__VITE_ASSET__CMQIFvM7__"